angular.module('dnecom')
    .controller('ProductProcessRelatedController', ["$scope", "ProductUtils", function ProductProcessRelatedController($scope, ProductUtils) {

        $scope.products = jQuery.map(TemplateData.value('products'), function (product, idx) {
            return {id: product.id, name: product.name}
        });
    }]);
